import moment from 'moment';

const getAggValue = (aggs, paths) => {
  if (!aggs || !Array.isArray(paths)) return 0;

  const foundKey = paths.find((p) => {
    const node = aggs[p];
    return (
      typeof node === 'number' ||
      (node && typeof node === 'object' && typeof node.value === 'number')
    );
  });

  if (!foundKey) return 0;

  const node = aggs[foundKey];
  return typeof node === 'number' ? node : (node.value ?? 0);
};

const parseShortSummary = (aggs = {}, options = {}) => {
  const { startDate, endDate, currency = '' } = options;

  const totalProductsQuantity = getAggValue(aggs, ['total_sales_count']);
  const totalPrice = getAggValue(aggs, ['total_amount']);
  const totalCost = getAggValue(aggs, ['total_cost']);
  const totalProfit = getAggValue(aggs, ['total_profit']);

  let periodLabel = '';
  if (startDate && endDate) {
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    periodLabel = `${start} — ${end}`;
  }

  return {
    periodLabel,
    totalProductsQuantity,
    totalPrice,
    totalCost,
    totalProfit,
    currency
  };
}

export default parseShortSummary;